// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.travel-main {
    width: 100%;
}

.basic-travel {
    padding: 75px 45px;
    padding-bottom: 0%;
    width: 100%;
}

.travel-heading-div {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    gap: 50px;
    width: 100% !important;
}

.travel-heading-text-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.travel-heading-text {
    font-size: 56px;
    font-weight: 400;
    line-height: 1.1;
    margin-bottom: 20px;
    font-family: 'Google Sans Regular', sans-serif;
}

.travel-header-detail-text {
    font-size: 20px;
    line-height: 1.5;
    font-family: 'Google Sans Regular', sans-serif;
}

.travel-maps-container {
    padding: 48px 0;
    max-width: 1400px;
    margin: 0 auto;
}

.map-section {
    background-color: transparent;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 60px;
}

.map-title {
    text-align: center;
    font-size: 30px;
    margin-bottom: 20px;
    font-family: 'Google Sans Regular', sans-serif;
}

.map-separator {
    height: 2px;
    background: rgba(255, 255, 255, 0.1);
    margin: 40px 0;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
}

@media (max-width: 768px) {
    .basic-travel {
        padding: 30px 20px;
    }

    .travel-heading-div {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .travel-heading-text {
        font-size: 40px;
    }

    .travel-header-detail-text {
        font-size: 18px;
    }

    .map-title {
        font-size: 24px;
    }
}

.vietnam-map-section {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}

/* Travel Stats */
.travel-stats-container {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin: 40px 0 60px 0;
    flex-wrap: wrap;
}

.stat-card {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 24px;
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    backdrop-filter: blur(10px);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    border-color: rgba(255, 255, 255, 0.2);
}

.stat-icon {
    font-size: 2.5rem;
    margin-bottom: 10px;
}

.stat-title {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 5px;
}

.stat-percentage {
    font-size: 2.5rem;
    font-weight: 700;
    margin: 10px 0;
    font-family: 'Google Sans Bold', sans-serif;
}

.stat-subtitle {
    font-size: 0.9rem;
    opacity: 0.7;
    margin-bottom: 15px;
}

.progress-container {
    width: 100%;
    height: 8px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    border-radius: 4px;
    transition: width 1.5s cubic-bezier(0.4, 0, 0.2, 1);
}

@media (max-width: 768px) {
    .travel-stats-container {
        flex-direction: column;
        align-items: center;
        gap: 20px;
        margin: 30px 0;
    }

    .stat-card {
        width: 100%;
        max-width: 350px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/travel/Travel.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mDAAmD;AACvD;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,SAAS;QACT,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ","sourcesContent":[".travel-main {\n    width: 100%;\n}\n\n.basic-travel {\n    padding: 75px 45px;\n    padding-bottom: 0%;\n    width: 100%;\n}\n\n.travel-heading-div {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));\n    gap: 50px;\n    width: 100% !important;\n}\n\n.travel-heading-text-div {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.travel-heading-text {\n    font-size: 56px;\n    font-weight: 400;\n    line-height: 1.1;\n    margin-bottom: 20px;\n    font-family: 'Google Sans Regular', sans-serif;\n}\n\n.travel-header-detail-text {\n    font-size: 20px;\n    line-height: 1.5;\n    font-family: 'Google Sans Regular', sans-serif;\n}\n\n.travel-maps-container {\n    padding: 48px 0;\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n.map-section {\n    background-color: transparent;\n    padding: 20px;\n    border-radius: 10px;\n    margin-bottom: 60px;\n}\n\n.map-title {\n    text-align: center;\n    font-size: 30px;\n    margin-bottom: 20px;\n    font-family: 'Google Sans Regular', sans-serif;\n}\n\n.map-separator {\n    height: 2px;\n    background: rgba(255, 255, 255, 0.1);\n    margin: 40px 0;\n    width: 80%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n@media (max-width: 768px) {\n    .basic-travel {\n        padding: 30px 20px;\n    }\n\n    .travel-heading-div {\n        grid-template-columns: 1fr;\n        gap: 20px;\n    }\n\n    .travel-heading-text {\n        font-size: 40px;\n    }\n\n    .travel-header-detail-text {\n        font-size: 18px;\n    }\n\n    .map-title {\n        font-size: 24px;\n    }\n}\n\n.vietnam-map-section {\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n/* Travel Stats */\n.travel-stats-container {\n    display: flex;\n    justify-content: center;\n    gap: 40px;\n    margin: 40px 0 60px 0;\n    flex-wrap: wrap;\n}\n\n.stat-card {\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 16px;\n    padding: 24px;\n    width: 300px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    backdrop-filter: blur(10px);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.stat-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n    border-color: rgba(255, 255, 255, 0.2);\n}\n\n.stat-icon {\n    font-size: 2.5rem;\n    margin-bottom: 10px;\n}\n\n.stat-title {\n    font-size: 1.2rem;\n    font-weight: 600;\n    margin-bottom: 5px;\n}\n\n.stat-percentage {\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin: 10px 0;\n    font-family: 'Google Sans Bold', sans-serif;\n}\n\n.stat-subtitle {\n    font-size: 0.9rem;\n    opacity: 0.7;\n    margin-bottom: 15px;\n}\n\n.progress-container {\n    width: 100%;\n    height: 8px;\n    background: rgba(255, 255, 255, 0.1);\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.progress-bar {\n    height: 100%;\n    border-radius: 4px;\n    transition: width 1.5s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@media (max-width: 768px) {\n    .travel-stats-container {\n        flex-direction: column;\n        align-items: center;\n        gap: 20px;\n        margin: 30px 0;\n    }\n\n    .stat-card {\n        width: 100%;\n        max-width: 350px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
